import { formatDate } from '@rhino-project/core/i18n/format';

/**
 * The display format for a timestamp shown alongside player activity — notes,
 * reports and history entries. Records here span seasons, so the year is part
 * of the format rather than something a reader infers from position in a list.
 */
export const formatActivityDate = (value: string | Date): string =>
  formatDate(value);
